<form [formGroup]="form">
  <div class="form-group validateMe">
    <label class="form-label" for="Country">{{ 'lang.address.country' | translate }}<span class="red" *ngIf="!noValidation">*</span></label>
    <select class="form-select" formControlName="AddressCountry" id="Country" name="Country">
      <option *ngFor="let country of countryListIsoCodes; let i = index" [selected]="country === _selectedCountry"
              value="{{country}}">{{ ('lang.iso.' + country)|translate }}
      </option>
    </select>
    <div *ngIf="AddressCountry.dirty && AddressCountry.errors?.required"
         class="alert alert-danger">{{ 'lang.address.CountryWarning' | translate }}
    </div>
  </div>
</form>
